import React from 'react';

const WhyCaptiveWorks = () => {
  const reasons = [
    {
      number: '01',
      title: 'Industry Expertise',
      description: 'Built by insurance and real estate professionals who understand both sides of the equation.'
    },
    {
      number: '02',
      title: 'Turnkey Platform',
      description: 'From feasibility to filing, all under one roof. We manage every aspect of your captive program — from domicile selection to regulatory filings to daily operations — so you focus on your business. Think of us as your captives entire back office, without the overhead.'
    },
    {
      number: '03',
      title: 'Customizable Structures',
      description: 'Choose your captive structures with single parent, group captives, cell captives, or rent-a-captives. Our experts help you determine the best structure to accomplish your risk management goals.'
    },
    {
      number: '04',
      title: 'Regulatory Peace of Mind',
      description: 'Full compliance, ongoing governance, and audited reporting.'
    },
    {
      number: '05',
      title: 'Aligned Incentives',
      description: 'We help you restructure underwriting profits and improve resident satisfaction.'
    }
  ];

  const options = [
    {
      title: 'Direct Captive Formation',
      description: 'We handle everything end-to-end, from feasibility analysis to ongoing administration and compliance management.'
    },
    {
      title: 'Agency Partnership',
      description: 'We integrate seamlessly with your existing broker or captive manager, providing compliance technology and resident enrollment.'
    }
  ];

  const companyLogos = [
    { name: 'AON', image: 'aon.svg' },
    { name: 'Conner', image: 'conner.svg' },
    { name: 'NFP', image: 'brown.svg' },
    { name: 'Gallagher', image: 'gallagher.svg' },
    { name: 'ID', image: 'marsh.svg' },
    { name: 'Lockton', image: 'Lockton.svg' },
    { name: 'HUB', image: 'Hub.svg' },
    { name: 'Artex', image: 'artex.svg' }
  ];

  return (
    <section className="why-work-wrapper">
      {/* Vertical Dividers */}
      <div className="why-work-divider why-work-divider-1"></div>
      <div className="why-work-divider why-work-divider-2"></div>
      <div className="why-work-divider why-work-divider-3"></div>
      <div className="why-work-divider why-work-divider-4"></div>
      <div className="why-work-divider why-work-divider-5"></div>

      {/* Why CaptiveWorks Header */}
      <div className="why-header-section">
        <h2 className="why-header-title">Why CaptiveWorks?</h2>
        <p className="why-header-description">
          Get up and running in weeks, not months. Our streamlined process take you from feasibility to full operation.
        </p>
      </div>

      {/* Why CaptiveWorks Grid */}
      <div className="why-grid-combined">
        {reasons.map((reason, index) => {
          // Card 2 (index 1) has right border
          const hasRightBorder = index === 1;
          const isFifthCard = index === 4;
          const isThirdCard = index === 2; // Customizable Structures
          const isFourthCard = index === 3; // Regulatory Peace of Mind
          
          // Position cards 3 and 4 on the right (columns 3-4)
          let gridColumn = '';
          if (isThirdCard) {
            gridColumn = 'grid-col-3';
          } else if (isFourthCard) {
            gridColumn = 'grid-col-4';
          }
          
          return (
            <div 
              className={`why-card-combined ${hasRightBorder ? 'has-right-border' : 'no-right-border'} ${isFifthCard ? 'fifth-card' : ''} ${gridColumn}`}
              key={index}
            >
              <div className="why-card-content">
                <h3 className="why-card-title">{reason.title}</h3>
                <p className="why-card-description">{reason.description}</p>
              </div>
              <div className="why-number-combined">{reason.number}</div>
            </div>
          );
        })}
      </div>

      {/* Work with Us Header */}
      <div className="work-header-section">
        <h2 className="work-header-title">Work with Us, Your Way</h2>
        <p className="work-header-description">
          We can help you set up a captive directly, or partner seamlessly with your existing insurance agency or broker.
        </p>
      </div>

      {/* Partner Logos Grid */}
      <div className="partners-logos-combined">
        {companyLogos.map((logo, index) => (
          <div 
            className={`partner-logo-combined ${index < 4 ? 'top-row' : 'bottom-row'} ${index % 4 === 3 ? 'no-right-border' : ''}`} 
            key={index}
          >
            <img 
              src={process.env.PUBLIC_URL + `/images/${logo.image}`}
              alt={logo.name}
              className="partner-logo-img"
            />
          </div>
        ))}
      </div>

      {/* Work Options Grid */}
      <div className="work-options-combined">
        {options.map((option, index) => (
          <div className="work-option-combined" key={index}>
            <div className="work-option-content">
              <h3 className="work-option-title">{option.title}</h3>
              <p className="work-option-description">{option.description}</p>
            </div>
            <div className="work-option-icon-combined">
              {index === 0 ? (
                <img 
                  src={process.env.PUBLIC_URL + '/images/dirct-captive-formation.svg'} 
                  alt="Direct Captive Formation"
                  className="work-option-icon-img"
                />
              ) : (
                <img 
                  src={process.env.PUBLIC_URL + '/images/agency-partnership.svg'} 
                  alt="Agency Partnership"
                  className="work-option-icon-img"
                />
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Corner Indicators */}
      <div className="why-work-corner why-work-corner-1"></div>
      <div className="why-work-corner why-work-corner-2"></div>
      <div className="why-work-corner why-work-corner-3"></div>
      <div className="why-work-corner why-work-corner-4"></div>
    </section>
  );
};

export default WhyCaptiveWorks;
